import EntityPage from "../../components/pages/EntityPage.tsx";
import DashboardLayout from "@/layout/DashboardLayout.tsx";

export default function EntityView() {
    return (
        <DashboardLayout>
            <EntityPage/>
        </DashboardLayout>
    );
}
